module.exports = __webpack_public_path__ + "img/failedpurchase.6cf7c445.png";